import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarning = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 44,
	height: 31,
	viewBox: "0 0 33.893 30.239",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "warning_black_24dp_3_",
		"data-name": "warning_black_24dp (3)",
		d: "M6.027,34.231H32.8A3.555,3.555,0,0,0,35.879,28.9L22.491,5.766a3.554,3.554,0,0,0-6.152,0L2.951,28.9a3.555,3.555,0,0,0,3.076,5.334ZM19.415,21.786a1.783,1.783,0,0,1-1.778-1.778V16.452a1.778,1.778,0,1,1,3.556,0v3.556A1.783,1.783,0,0,1,19.415,21.786ZM21.193,28.9H17.637V25.342h3.556Z",
		transform: "translate(-2.469 -3.992)",
		fill: "#fad753"
	})
});
export { SvgWarning as ReactComponent };
